import { createStateHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useGlobalSettingsState = createStateHook(
  AppStoreProvider,
  state => state.pages.globalSettings
)
